import { useState } from "react";
import {
    Button,
    FormControl,
    FormGroup,
    FormLabel,
    Modal,
    Tab,
    Tabs,
    Offcanvas,
    FormSelect,
} from "react-bootstrap";
// import EditIcon from "../../../images/edit-icon.svg";
import DeleteIcon from "../../../images/delete-icon.svg";
import FileUploader from "../FileUploader/FileUpload.tsx";
import FileIcon from "../../../images/delete-file.svg";
import MinusIcon from "../../../images/minus.png";
import PlusIcon from "../../../images/plus.png";
import Monetary from "./Monetary.tsx";
import GiftCard from "./GiftCard.tsx";
import PhysicalItem from "./PhysicalItem.tsx";
import "./GiftManagement.scss";

interface PhysicalItemType {
    id: number;
    image: string;
    title: string;
    description: string;
    category: string;
    price: string;
}

const GiftManagement = () => {
    const [activeKey, setActiveKey] = useState("monetary");
    const [showAddModal, setShowAddModal] = useState(false);
    const [showAddDrawer, setShowAddDrawer] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState<string | null>(null);
    const [showEditDrawer, setShowEditDrawer] = useState(false);
    const [editTitle, setEditTitle] = useState<string>("");
    const [editImage, setEditImage] = useState<any>(null);
    const [editItemId, setEditItemId] = useState<number | null>(null);

    const [denominations, setDenominations] = useState<string[]>([""]);

    // Form fields for physical item
    const [physicalTitle, setPhysicalTitle] = useState("");
    const [physicalCategory, setPhysicalCategory] = useState("");
    const [physicalPrice, setPhysicalPrice] = useState("");
    const [physicalDescription, setPhysicalDescription] = useState("");
    const [physicalNotes, setPhysicalNotes] = useState("");

    const handleAddDenomination = () => {
        setDenominations([...denominations, ""]);
    };

    const handleRemoveDenomination = (index: number) => {
        const updated = denominations.filter((_, i) => i !== index);
        setDenominations(updated);
    };

    const handleChangeDenomination = (index: number, value: string) => {
        const updated = [...denominations];
        updated[index] = value;
        setDenominations(updated);
    };

    const handleAddShow = () => {
        if (activeKey === "giftCard" || activeKey === "physicalItem") {
            setShowAddDrawer(true);
        } else {
            setShowAddModal(true);
        }
    };

    const handleAddClose = () => setShowAddModal(false);
    const handleAddDrawerClose = () => setShowAddDrawer(false);

    const handleDeleteShow = (target: string) => {
        setDeleteTarget(target);
        setShowDeleteModal(true);
    };
    const handleDeleteClose = () => setShowDeleteModal(false);
    const handleConfirmDelete = () => {
        handleDeleteClose();
    };

    const handleEditShow = (item: { name: string; img: any }) => {
        setEditTitle(item.name);
        setEditImage(item.img);
        setShowEditDrawer(true);
    };

    const handleEditPhysical = (item: PhysicalItemType) => {
        setEditTitle(item.title);
        setEditImage(item.image);
        setEditItemId(item.id);
        setShowEditDrawer(true);
    };

    const handleDeletePhysical = (id: number) => {
        setDeleteTarget(id.toString());
        setShowDeleteModal(true);
    };

    const handleEditClose = () => setShowEditDrawer(false);

    return (
        <section className="main-body">
            <div className="management-sec">
                <div className="management-sec-in">
                    <div className="main-tabs">
                        <div className="d-flex justify-content-between align-items-center">
                            <aside className="tabs col-xl-8">
                                <Tabs
                                    activeKey={activeKey}
                                    onSelect={(k) => setActiveKey(k || "monetary")}
                                    id="gift-management-tabs"
                                    className="mb-3"
                                >
                                    <Tab eventKey="monetary" title="Monetary" />
                                    <Tab eventKey="giftCard" title="Gift Card" />
                                    <Tab eventKey="physicalItem" title="Physical Item" />
                                </Tabs>
                            </aside>
                            {/* <aside className="button">
                                <Button className="main-bttn" onClick={handleAddShow}>
                                    Add New
                                </Button>
                            </aside> */}
                        </div>
                    </div>

                    <div className="tab-content tab-body">
                        {activeKey === "monetary" && (
                            <Monetary onEdit={handleEditShow} onDelete={handleDeleteShow} />
                        )}
                        {activeKey === "giftCard" && (
                            <GiftCard onEdit={handleEditShow} onDelete={handleDeleteShow} />
                        )}
                        {activeKey === "physicalItem" && (
                            <PhysicalItem
                                onEdit={handleEditPhysical}
                                onDelete={handleDeletePhysical}
                            />
                        )}
                    </div>
                </div>
            </div>


            {/* Add Drawer (For Gift Card / Physical Item) */}
            <Offcanvas show={showAddDrawer} onHide={handleAddDrawerClose} placement="end" className="edit-drawer">
                <Offcanvas.Header closeButton className="px-0">
                    <Offcanvas.Title>
                        Add New {activeKey === "giftCard" ? "Gift Card" : "Physical Item"}
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="px-0">
                    {activeKey === "giftCard" && (
                        <>
                            <FormGroup className="form-group">
                                <FormLabel>Title</FormLabel>
                                <FormControl type="text" placeholder="Amazon Gift Card" />
                            </FormGroup>

                            <FormGroup className="form-group">
                                <FormLabel>Denomination</FormLabel>
                                <div>
                                    {denominations.map((value, index) => (
                                        <div className="denomination mb-2" key={index}>
                                            <FormControl
                                                type="text"
                                                placeholder="Enter..."
                                                value={value}
                                                onChange={(e) => handleChangeDenomination(index, e.target.value)}
                                            />
                                            <span onClick={() => handleRemoveDenomination(index)} style={{ cursor: "pointer" }}>
                                                <img src={MinusIcon} alt="Remove" />
                                            </span>
                                        </div>
                                    ))}
                                    <div className="add" onClick={handleAddDenomination} style={{ cursor: "pointer" }}>
                                        <img src={PlusIcon} alt="Add" />
                                        <span>Add New</span>
                                    </div>
                                </div>
                            </FormGroup>
                            <FileUploader />
                        </>
                    )}

                    {activeKey === "physicalItem" && (
                        <>
                            <FormGroup className="form-group">
                                <FormLabel>Title</FormLabel>
                                <FormControl
                                    type="text"
                                    placeholder="Flowers"
                                    value={physicalTitle}
                                    onChange={(e) => setPhysicalTitle(e.target.value)}
                                />
                            </FormGroup>

                            <FormGroup className="form-group">
                                <FormLabel>Category</FormLabel>
                                <FormSelect
                                    value={physicalCategory}
                                    onChange={(e) => setPhysicalCategory(e.target.value)}
                                >
                                    <option value="">Select Category</option>
                                    <option value="Flowers">Flowers</option>
                                    <option value="Chocolates">Chocolates</option>
                                    <option value="Gift Box">Gift Box</option>
                                </FormSelect>
                            </FormGroup>

                            <FormGroup className="form-group">
                                <FormLabel>Price ($)</FormLabel>
                                <FormControl
                                    type="number"
                                    placeholder="Enter Price"
                                    value={physicalPrice}
                                    onChange={(e) => setPhysicalPrice(e.target.value)}
                                />
                            </FormGroup>

                            <FormGroup className="form-group">
                                <FormLabel>Description</FormLabel>
                                <FormControl
                                    as="textarea"
                                    rows={3}
                                    placeholder="Enter Description"
                                    value={physicalDescription}
                                    onChange={(e) => setPhysicalDescription(e.target.value)}
                                />
                            </FormGroup>

                            <FormGroup className="form-group">
                                <FormLabel>Notes</FormLabel>
                                <FormControl
                                    as="textarea"
                                    rows={2}
                                    placeholder="Additional Notes"
                                    value={physicalNotes}
                                    onChange={(e) => setPhysicalNotes(e.target.value)}
                                />
                            </FormGroup>

                            <FileUploader />
                        </>
                    )}
                    <Button className="main-bttn mt-4 w-100" onClick={handleAddDrawerClose}>
                        Add
                    </Button>
                </Offcanvas.Body>
            </Offcanvas>

            {/* Delete Modal */}
            <Modal className="delete-modal" show={showDeleteModal} onHide={handleDeleteClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span>
                        <img src={FileIcon} alt="" />
                        <p>Are you sure you want to delete this file?</p>
                    </span>
                </Modal.Body>
                <Modal.Footer className="border-0 text-left">
                    <Button className="border-bttn" variant="secondary" onClick={handleDeleteClose}>
                        Cancel
                    </Button>
                    <Button className="main-bttn" variant="danger" onClick={handleConfirmDelete}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Edit Drawer */}
            <Offcanvas show={showEditDrawer} onHide={handleEditClose} placement="end" className="edit-drawer">
                <Offcanvas.Header closeButton className="px-0">
                    <Offcanvas.Title>Edit Item</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="px-0">
                    <FormGroup className="form-group">
                        <FormLabel>Title</FormLabel>
                        <FormControl
                            type="text"
                            placeholder="Title"
                            value={editTitle}
                            onChange={(e) => setEditTitle(e.target.value)}
                        />
                    </FormGroup>
                    {editImage && (
                        <div className="image-preview position-relative mt-3">
                            <img src={editImage} alt="Preview" className="img-fluid rounded" />
                            <Button
                                variant="link"
                                className="position-absolute top-0 end-0 p-1"
                                onClick={() => setEditImage(null)}
                            >
                                <img src={DeleteIcon} alt="Delete" />
                            </Button>
                        </div>
                    )}
                    <Button className="main-bttn mt-4 w-100" onClick={handleEditClose}>
                        Update
                    </Button>
                </Offcanvas.Body>
            </Offcanvas>
        </section>
    );
};

export default GiftManagement;
